import { UIEndGameShareImage } from './UIEndGameShareImage.ts';
import { createDivIn, createExternalImgIn, createHeaderIn, createParagraphIn } from '../ui_utils/DomUtils.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerTitleEnum } from '@colonist/game-states';
import PlayerHighlight from '@static/images/player_highlight.png';
export class UIEndGameTitleImage extends UIEndGameShareImage {
    async generateImage() {
        this.createHeader();
        await super.generateImage();
        this.contentContainer.classList.add('with-header');
    }
    createHeader() {
        const header = createDivIn(this.container, 'share-image-header');
        const playerTitleTextDiv = createDivIn(header, 'share-image-header-text');
        const playerTitleKey = EnumUtils.getEnumKey(this.title, PlayerTitleEnum);
        const title = {
            key: `strings:game.endGame.playerTitles.${playerTitleKey}.title`
        };
        const description = {
            key: `strings:game.endGame.playerTitles.${playerTitleKey}.description`
        };
        createHeaderIn(playerTitleTextDiv, title, 'share-image-header-title');
        createParagraphIn(playerTitleTextDiv, description, 'share-image-header-description');
    }
    createPlayerAvatar(container, player) {
        const isLocalPlayer = player.color == this.uiGameManager.gameController.myColor;
        if (isLocalPlayer) {
            createExternalImgIn(container, PlayerHighlight, {
                key: 'strings:colonistCommon.utils.emptyString'
            }, 'share-image-player-highlight');
        }
        super.createPlayerAvatar(container, player);
    }
    // eslint-disable-next-line class-methods-use-this
    shouldCreatePlayerCrown(playerColor, numPlayers) {
        return false;
    }
    constructor(uiGameManager, title, endGameState){
        super(uiGameManager, endGameState);
        this.title = title;
    }
}
